export { default } from './FavoritesRibbon';
